import type { GetJournalEntriesReportResponsePayload } from '@vy/api-definition';
import { GetJournalEntriesReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function journalEntriesReportQuery() {
  const api = getPrivateApi();
  const journalEntriesReport = await api.getJournalEntriesReport();

  return GetJournalEntriesReportResponseSchema.parse(journalEntriesReport);
}

export function useJournalEntriesReport(
  options?: CustomUseQueryOptions<GetJournalEntriesReportResponsePayload>,
) {
  const getJournalEntriesReportQuery = useQuery(
    queryKeys.journalEntriesReport(),
    () => journalEntriesReportQuery(),
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getJournalEntriesReportQuery.data, 'getJournalEntriesReportQuery data');

  return getJournalEntriesReportQuery;
}
